// FassalkartAI — Environment Variable Validation
// Call checkEnvironment() on app startup to catch missing config early.
//
// This file must NOT read process.env directly. It reads the vetted, statically
// inlined surface in utils/clientEnv.js — see the long comment there for why a
// computed process.env[key] lookup leaks every secret into the public bundle.
//
// There is no AI key client-side: inference is proxied through Cloud Functions
// (services/aiProvider.js) and the model credential lives in Secret Manager.

import { CLIENT_ENV, isConfigured } from "./clientEnv";

/** Without these the app cannot function at all. */
const REQUIRED_KEYS = [
  "FIREBASE_API_KEY",
  "FIREBASE_AUTH_DOMAIN",
  "FIREBASE_PROJECT_ID",
  "FIREBASE_STORAGE_BUCKET",
  "FIREBASE_MESSAGING_SENDER_ID",
  "FIREBASE_APP_ID",
];

/** Missing these degrades a feature but the app still runs. */
const OPTIONAL_KEYS = [
  "RECAPTCHA_SITE_KEY",
  "GOOGLE_MAPS_KEY",
  "WEATHER_CF_URL",
];

export function checkEnvironment() {
  const missing = REQUIRED_KEYS.filter((k) => !isConfigured(CLIENT_ENV[k]));
  const warnings = OPTIONAL_KEYS.filter((k) => !isConfigured(CLIENT_ENV[k]));

  if (missing.length > 0) {
    console.error("MISSING REQUIRED ENV VARS:", missing);
  }
  if (warnings.length > 0 && CLIENT_ENV.NODE_ENV === "development") {
    console.warn("OPTIONAL ENV VARS NOT SET:", warnings);
  }

  return { isReady: missing.length === 0, missing, warnings };
}

export default checkEnvironment;
